/**
 * ░█▀▄░▀▀█░▀▀█░█▀█░█▀█░█▀█
 * ░█░█░░▀▄░░▀▄░█▀▀░█▀█░█░█
 * ░▀▀░░▀▀░░▀▀░░▀░░░▀░▀░▀░▀
 *
 * @author d33pan on 8/13/2026
 */

export class Base64Util {
  /**
   * @param data An input to encode.
   */
  public static encode(data: any): string {
    return btoa(data);
  }

  /**
   * @param data A Base64 encoded string.
   */
  public static decode(data: any): string {
    return atob(data);
  }
}
